module.exports = __webpack_public_path__ + "img/lock2.8e1ea849.svg";